import { render, staticRenderFns } from "./floorDetail.vue?vue&type=template&id=05d778ea&scoped=true"
import script from "./floorDetail.vue?vue&type=script&lang=js"
export * from "./floorDetail.vue?vue&type=script&lang=js"
import style0 from "./floorDetail.vue?vue&type=style&index=0&id=05d778ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d778ea",
  null
  
)

export default component.exports